import supermarketImage from "../assets/supermarket-system-ug.jpg";

const Supermarket = () => {
  return (
    <div className="w-full p-0">
      <img src={supermarketImage} className="w-full m-0"/>
    </div>
  );
};

export { Supermarket };
export default Supermarket;
